import {Trans, useTranslation} from 'react-i18next';
import {Check} from 'lucide-react';

type SceneChecklistProps = {
  headKey: string;
  rowKeys: string[];
};

function SceneChecklist({headKey, rowKeys}: Readonly<SceneChecklistProps>) {
  const {t} = useTranslation();

  return (
    <div className="mt-[22px] flex w-full max-w-[340px] flex-col gap-[9px] rounded-[var(--chekin-radius-lg)] bg-white px-[15px] py-3.5 text-left">
      <div className="text-[12px] font-bold uppercase tracking-[0.09em] text-[color:var(--chekin-text-secondary)]">
        {t(headKey)}
      </div>
      {rowKeys.map(key => (
        <div
          key={key}
          className="flex items-start gap-2.5 text-[14px] leading-5 text-[color:var(--chekin-text-secondary)]"
        >
          <span
            aria-hidden="true"
            className="grid size-5 shrink-0 place-items-center rounded-md bg-[var(--chekin-green-50)] text-[color:var(--chekin-green-700)]"
          >
            <Check size={13} strokeWidth={3} />
          </span>
          <span>
            <Trans
              i18nKey={key}
              components={[
                <b className="font-semibold text-[color:var(--chekin-text-primary)]" />,
              ]}
            />
          </span>
        </div>
      ))}
    </div>
  );
}

export {SceneChecklist};
